import { TCompanyLocation } from "../../../api/modules/Company/types";

export const DEFAULT_LOCATION = (companyId: number): TCompanyLocation => ({
  companyId,
  latitude: null,
  longitude: null,
  radius: null,
  zipcode: null,
});
